<template>
  <span>
    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 39"
      :src="require('@/assets/img/mapa/TUR/TUR-A-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 40"
      :src="require('@/assets/img/mapa/TUR/TUR-A-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 41"
      :src="require('@/assets/img/mapa/TUR/TUR-A-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 42"
      :src="require('@/assets/img/mapa/TUR/TUR-A-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 43"
      :src="require('@/assets/img/mapa/TUR/TUR-A-3-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 44"
      :src="require('@/assets/img/mapa/TUR/TUR-A-3-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 45"
      :src="require('@/assets/img/mapa/TUR/TUR-B-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 46"
      :src="require('@/assets/img/mapa/TUR/TUR-B-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 47"
      :src="require('@/assets/img/mapa/TUR/TUR-B-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 48"
      :src="require('@/assets/img/mapa/TUR/TUR-B-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 49"
      :src="require('@/assets/img/mapa/TUR/TUR-i-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 50"
      :src="require('@/assets/img/mapa/TUR/TUR-i-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 51"
      :src="require('@/assets/img/mapa/TUR/TUR-i-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 52"
      :src="require('@/assets/img/mapa/TUR/TUR-i-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>
  </span>
</template>

<script>
export default {
  props: {
    perguntaObj: { type: Object, required: true }
  }
}
</script>
